import { LAYOUT_TYPES } from '@/config/app';

import type { LayoutDetails } from './types';
import { Layout } from './types';

// as other JS files are also using LAYOUT_TYPES, will be converted to an enum later on
type LayoutTypeKeys = keyof typeof LAYOUT_TYPES;

const LAYOUT_DETAILS: Record<(typeof LAYOUT_TYPES)[LayoutTypeKeys], LayoutDetails> = {
    [LAYOUT_TYPES.MOBILE]: {
        default: Layout.TWO_COLUMN,
        layouts: [Layout.ONE_COLUMN, Layout.TWO_COLUMN],
    },
    [LAYOUT_TYPES.TABLET]: {
        default: Layout.FOUR_COLUMN,
        layouts: [Layout.FOUR_COLUMN],
    },
    [LAYOUT_TYPES.DESKTOP]: {
        default: Layout.SIX_COLUMN,
        layouts: [Layout.FOUR_COLUMN, Layout.SIX_COLUMN, Layout.EIGHT_COLUMN],
    },
};

const LAYOUT_COOKIE_NAME = 'media_layout';

const LIST_COUNTER_INITIAL_VALUE = 1;

export { LAYOUT_COOKIE_NAME, LAYOUT_DETAILS, LIST_COUNTER_INITIAL_VALUE };
